import axios from "axios";
export const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_KEY,
});

Api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token !== undefined) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (errMsg) => {
    return Promise.reject(errMsg);
  }
);

Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (errMsg) => {
    if (errMsg.response.status === 401) {
      localStorage.clear();
      window.location =
        window.location.protocol + "//" + window.location.host + "/";
    }
    return Promise.reject(errMsg);
  }
);
